import url from 'url';

export const getUrlQueryParameters = () => {
  const href = (window && window.location && window.location.href) || '';
  return url.parse(href, true).query;
};

export const getCurrentUrlPath = () => {
  return (window && window.location && window.location.pathname) || '';
};

export const getUrlHostName = () => {
  return (window && window.location && window.location.hostname) || '';
};

export const getUrlPort = () => {
  return (window && window.location && window.location.port) || '';
};

export const isProductionUrl = () => {
  const urlHost = getUrlHostName();
  return urlHost && urlHost === 'www.pandora.com';
};

export function isUrlLocal(urlString) {
  const { hostname } = url.parse(urlString);
  return hostname === getUrlHostName();
}

export function getUrlParseObject(urlString, parseQueryString = false) {
  return url.parse(urlString, parseQueryString);
}

export function getProxiedAudioURL(originalAudioUrl) {
  const parsedUrl = url.parse(originalAudioUrl);
  const { hostname, path, protocol = 'https:' } = parsedUrl;
  const port = parsedUrl.port ? parsedUrl.port : protocol === 'https:' ? '443' : '80';
  const originalHost = encodeURIComponent(protocol + '//' + hostname + ':' + port);
  return `${AUDIO_URL_DEV_PROXY}${path}&originalHost=${originalHost}`;
}
